import { errorClass, errorClassWithData } from 'error-kid';

export class CancelledError extends errorClass('CancelledError', 'Promise was canceled') {
}

export class TimeoutError extends errorClassWithData<
  { timeout: number },
  [timeout: number, cause?: unknown]
>(
  'TimeoutError',
  timeout => ({ timeout }),
  (timeout, cause) => [`Timeout reached: ${timeout}ms`, { cause }],
) {
}